// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://api.fontshare.com/v2/css?f[]=chillax@400,500,600,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.entry-animation-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #050505; /* Deep cinematic black */
    z-index: 99999;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: opacity 1.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.entry-animation-container.fade-out {
    opacity: 0;
    pointer-events: none;
}

.entry-animation-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
}

.entry-logo {
    width: 120px;
    height: auto;
    opacity: 0;
    filter: blur(10px);
    transform: scale(0.8) translateY(20px);
    animation: cinematic-logo-reveal 2s cubic-bezier(0.16, 1, 0.3, 1) 0.2s forwards;
}

.entry-text {
    font-family: 'Chillax', sans-serif;
    font-size: 56px;
    font-weight: 600;
    color: #ffffff;
    letter-spacing: 2px;
    margin: 0;
    opacity: 0;
    filter: blur(10px);
    transform: translateY(20px);
    animation: cinematic-text-reveal 2.5s cubic-bezier(0.16, 1, 0.3, 1) 0.6s forwards;
}

@keyframes cinematic-logo-reveal {
    0% {
        opacity: 0;
        filter: blur(10px);
        transform: scale(0.8) translateY(20px);
    }
    100% {
        opacity: 1;
        filter: blur(0px);
        transform: scale(1) translateY(0);
    }
}

@keyframes cinematic-text-reveal {
    0% {
        opacity: 0;
        filter: blur(10px);
        transform: translateY(20px);
        letter-spacing: 2px;
    }
    100% {
        opacity: 1;
        filter: blur(0px);
        transform: translateY(0);
        letter-spacing: 16px; /* Cinematic spacing expansion */
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/entry_animation/EntryAnimation.css"],"names":[],"mappings":"AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,yBAAyB,EAAE,yBAAyB;IACpD,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,6DAA6D;AACjE;;AAEA;IACI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,sCAAsC;IACtC,+EAA+E;AACnF;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,2BAA2B;IAC3B,iFAAiF;AACrF;;AAEA;IACI;QACI,UAAU;QACV,kBAAkB;QAClB,sCAAsC;IAC1C;IACA;QACI,UAAU;QACV,iBAAiB;QACjB,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,UAAU;QACV,kBAAkB;QAClB,2BAA2B;QAC3B,mBAAmB;IACvB;IACA;QACI,UAAU;QACV,iBAAiB;QACjB,wBAAwB;QACxB,oBAAoB,EAAE,gCAAgC;IAC1D;AACJ","sourcesContent":["@import url('https://api.fontshare.com/v2/css?f[]=chillax@400,500,600,700&display=swap');\n\n.entry-animation-container {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: #050505; /* Deep cinematic black */\n    z-index: 99999;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    transition: opacity 1.2s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n\n.entry-animation-container.fade-out {\n    opacity: 0;\n    pointer-events: none;\n}\n\n.entry-animation-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 32px;\n}\n\n.entry-logo {\n    width: 120px;\n    height: auto;\n    opacity: 0;\n    filter: blur(10px);\n    transform: scale(0.8) translateY(20px);\n    animation: cinematic-logo-reveal 2s cubic-bezier(0.16, 1, 0.3, 1) 0.2s forwards;\n}\n\n.entry-text {\n    font-family: 'Chillax', sans-serif;\n    font-size: 56px;\n    font-weight: 600;\n    color: #ffffff;\n    letter-spacing: 2px;\n    margin: 0;\n    opacity: 0;\n    filter: blur(10px);\n    transform: translateY(20px);\n    animation: cinematic-text-reveal 2.5s cubic-bezier(0.16, 1, 0.3, 1) 0.6s forwards;\n}\n\n@keyframes cinematic-logo-reveal {\n    0% {\n        opacity: 0;\n        filter: blur(10px);\n        transform: scale(0.8) translateY(20px);\n    }\n    100% {\n        opacity: 1;\n        filter: blur(0px);\n        transform: scale(1) translateY(0);\n    }\n}\n\n@keyframes cinematic-text-reveal {\n    0% {\n        opacity: 0;\n        filter: blur(10px);\n        transform: translateY(20px);\n        letter-spacing: 2px;\n    }\n    100% {\n        opacity: 1;\n        filter: blur(0px);\n        transform: translateY(0);\n        letter-spacing: 16px; /* Cinematic spacing expansion */\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
